import { render } from "./SignicatVerify.vue?vue&type=template&id=514426de&scoped=true&ts=true"
import script from "./SignicatVerify.vue?vue&type=script&lang=ts"
export * from "./SignicatVerify.vue?vue&type=script&lang=ts"

import "./SignicatVerify.vue?vue&type=style&index=0&id=514426de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514426de"]])

export default __exports__